<template>
    <div class="artists-container">
      <h1 class="page-title"></h1>
      
      <div class="artists-grid">
        <router-link 
          v-for="artist in artists" 
          :key="artist.id" 
          :to="{ name: 'ArtistPage', params: { id: artist.id }}" 
          class="artist-card"
        >
          <div class="artist-image-container">
            <img :src="artist.image" :alt="artist.name" class="artist-image">
            <div class="artist-name-overlay">
              <h3 class="artist-name">{{ artist.name }}</h3>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ArtistsPage',
    data() {
      return {
        artists: [
          { id: 1, name: '(ooo)', image: require('@/assets/images/artists/artist7-bg.jpg') },
          { id: 2, name: '在呼', image: require('@/assets/images/artists/artist3-bg.jpg') },
          { id: 3, name: '無色體', image: require('@/assets/images/artists/artist6-bg.jpg') },
          { id: 4, name: 'Pān-Toh', image: require('@/assets/images/artists/artist5-bg.jpg') },
          { id: 5, name: '予海', image: require('@/assets/images/artists/artist12-bg.jpg') },
          { id: 6, name: '01110100 01101111', image: require('@/assets/images/artists/artist11-bg.jpg') },
          { id: 7, name: '氣氛大師', image: require('@/assets/images/artists/artist9-bg.jpg') },
          { id: 8, name: '完美的代價', image: require('@/assets/images/artists/artist2-bg.jpg') },
          { id: 9, name: 'DR↺P', image: require('@/assets/images/artists/artist4-bg.jpg') },
          { id: 10, name: '心願Yeast', image: require('@/assets/images/artists/artist8-bg.jpg') },
          { id: 11, name: '不會動的手臂', image: require('@/assets/images/artists/artist1-bg.jpg') },
          { id: 12, name: '沒什麼好想的', image: require('@/assets/images/artists/artist10-bg.jpg') },
        ]
      }
    }
  }
  </script>
  
  <style scoped>
  .artists-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px 20px;
  }
  
  .page-title {
    color: #004D6B;
    margin-bottom: 40px;
    text-align: center;
    font-size: 36px;
  }
  
  .artists-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
  }
  
  .artist-card {
    text-decoration: none;
    color: inherit;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    transform: translateY(0);
  }
  
  .artist-card:hover {
    transform: translateY(-10px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  }
  
  .artist-image-container {
    height: 250px;
    overflow: hidden;
    position: relative;
  }
  
  .artist-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }
  
  .artist-card:hover .artist-image {
    transform: scale(1.05);
  }
  
  .artist-name-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 15px;
    background: linear-gradient(to top, #004d6b54, transparent);
    transition: all 0.3s ease;
  }
  
  .artist-name {
    text-align: center;
    font-weight: 500;
    color: white;
    margin: 0;
    text-shadow: 0 1px 3px rgba(0,0,0,0.5);
  }
  
  @media (max-width: 768px) {
    .artists-grid {
      grid-template-columns: 1fr;
      gap: 20px;
    }
    
    .artist-image-container {
      height: 180px;
    }
  }
  </style>